const QueryKeys = {
  WORKER_PROFILE: 'worker_profile',
  WORKER_PERSONAL_VIDEO_DOWNLOAD_URL: 'worker_personal_video_download_url',
  WORKER_OPTIONS: 'worker_options',
  WORKER_ASSIGNMENT_JOB: 'worker_assignment_job',
  WORKER_ACTIVITY_COMPANY: 'worker_activity_company',
  WORKER_AVAILABLE_CERTIFICATES: 'worker-profile-certificates',
  COMPANY_MEMBER_INDICATORS: 'company_member_indicators',
  COMPANY_JOBS: 'company_jobs',
  COMPANY_JOB_SHIFTS_LIST: 'company_job_shifts_list',
  COMPANY_JOB_SHIFTS_COUNTERS: 'company_job_shifts_counters',
  JOB_STATS_LIST: 'job_stats_list',
  JOB_SHIFTS_STATS_LIST: 'job_shifts_stats_list',
  JOB_NEW_APPLICANTS: 'job_new_applicants',
  JOB_CANDIDATES_STAGE: 'job_candidates_stage',
  COUNT_ACTIVE_JOBS: 'count_active_jobs',
  COUNT_NEW_APPLICANTS: 'count_new_applicants',
  COMPANY_JOB_DETAIL: 'company_job_detail',
  COMPANY_JOB_APPLICATION: 'company_job_application',
  COMPANY_JOB_COUNTERS: 'company_job_counters',
  COMPANY_JOB_SHIFTS: 'company_job_shifts',
  COMPANY_JOB_ACTIVITY_TRACKER: 'company_job_activity_tracker',
  COMPANY_JOB_SHIFTS_CREATE: 'create_job_shifts',
  COMPANY_JOB_CAN_CANCEL: 'company_job_can_cancel',
  COMPANY_TALENTS: 'company_talents',
  COMPANY_RATING: 'company_rating',
  COM_HUB_COMPANY_JOB_DETAIL: 'company_job_detail',
  JOB_TITLES: 'job_titles',
  WORKER_NOTES: 'worker_notes',
  WORKER_FILTERS: 'worker_filters',
  SHIFT_WORKERS_TO_OFFER: 'shift_workers_to_offer',
  WORKER_AVAILABILITIES: 'worker_availabilities',
  COMPANY_JOB_SHIFTS_OFFER: 'offer_job_shifts',
  MESSAGE_CONVERSATIONS: 'message_conversations',
  JOB_MESSAGE_CONVERSATIONS: 'job_message_conversations',
  DIRECT_MESSAGE_CONVERSATIONS: 'direct_message_conversations',
  MESSAGE_MESSAGES: 'message_messages',
  REVIEW_JOBS: 'review_jobs',
  SEARCH_JOBS_REVIEW: 'search_jobs_review',
  SURVEY_HISTORY: 'survey_history',
  SURVEY_PROFILING_DATA: 'survey_profiling_data',

  // Job Detail (DetailV2 candidates panel) QueryKeys
  JobDetail: {
    CANDIDATES: 'jobCandidates',
    CANDIDATE_COUNTERS: 'jobCandidateCounters',
  },

  // My Jobs QueryKeys
  MyJobs: {
    SAVE_JOB: 'my-jobs-save-job',
    UNSAVE_JOB: 'my-jobs-unsave-job',
    JOB_RECOMMENDATIONS: 'my-jobs-job-recommendations',
    JOB_RECOMMENDATION_BY_ID: 'my-jobs-job-recommendation-by-id',
    SAVED_JOBS: 'my-jobs-saved-jobs',
    COMPANIES_SUGGESTIONS: 'my-jobs-companies-suggestions',
  },

  // Worker Dashboard QueryKeys
  WorkerDashboard: {
    UPCOMING_JOBS: 'worker-dashboard-upcoming-jobs',
    FLIP_REVIEWS: 'worker-dashboard-flip-reviews',
    LEADERBOARD: 'worker-dashboard-leaderboard',
    LEVEL: 'worker-dashboard-level',
    JOBS_COUNTERS: 'worker-dashboard-jobs-counters',
  },

  // Worker Inbox QueryKeys
  WorkerInbox: {
    DIRECT_CHAT: 'worker-inbox-direct-chat',
    JOB_CHAT: 'worker-inbox-job-chat',
    TODOS: 'worker-inbox-todos',
    OTHER_NOTIFICATIONS: 'worker-inbox-other-notifications',
    INDICATORS: 'worker-inbox-indicators',
  },

  // COM HUB QueryKeys (Company)
  ComHub: {
    RECEIVED_REVIEWS: 'comunication-hub-received-reviews',
    RECEIVED_REVIEWS_COUNT: 'comunication-hub-received-reviews-count',
    REVIEW_REQUESTS: 'comunication-hub-review-requests',
    REVIEW_REQUESTS_COUNT: 'comunication-hub-review-requests-count',
    GIVEN_REVIEWS: 'comunication-hub-given-reviews',
    GIVEN_ENDORSEMENT: 'comunication-hub-given-endorsement',
    DIRECT_CHAT: 'comunication-hub-direct-chat',
    DIRECT_CHAT_COUNT: 'comunication-hub-direct-chat-count',
    JOB_CHAT: 'comunication-hub-job-chat',
    JOB_CHAT_COUNT: 'comunication-hub-job-chat-count',
    PENDING_REVIEWS: 'comunication-hub-pending-reviews',
  },
};

export default QueryKeys;
